import type { TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import type { SortDirectionType } from '@rio-cloud/rio-uikit/utils/SortUtils';

import type { TableColumn } from '../enums/TableColumn';
import type { TreeCategory } from '../tree/redux/types';

export enum TimeDisplayMode {
    CURRENT = 'current',
    REMAINING = 'remaining',
}

export interface PersistedSpaState {
    selectedAssetIds?: string[];
    selectedVehicleGroupIds?: string[];
    selectedDriverIds?: string[];
    selectedDriverGroupIds?: string[];
    selectedActivityIds?: string[];
    selectedTimestampIds?: string[];
    selectedHiddenColumnIds?: TableColumn[];
    selectedColumnOrderIds?: TableColumn[];
    selectedTimeDisplayMode?: string;
    selectedStateChangesDisplay?: boolean;
    drivingTimesChunkNumber?: number;
    stateChangesChunkNumber?: number;
    stateChangesStartNumber?: number;
    selectedDrivingTimesRowId?: string;
    selectedStateChangesRowId?: string;
    sortDir?: SortDirectionType;
    sortBy?: TableColumn;
    viewMode?: TableViewTogglesViewType;
    treeCategory?: TreeCategory;
}

export type Action = 'PUSH' | 'POP' | 'REPLACE';
